<script>
import CountdownBlock from '@/components/Launchpad/CountdownBlock';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { mapGetters } from 'vuex';

dayjs.extend(duration);

export default {
  name: 'Countdown',
  components: {
    CountdownBlock,
  },
  props: {
    chain: {
      type: Boolean,
    },
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      countdownStart: 0,
      timerStart: null,
      countdownEnd: 0,
      timerEnd: null,
    };
  },
  async mounted() {
    if (this.chain) {
      await this.$store.dispatch('Presale/presaleDate');
    }
    this.init();
  },
  beforeDestroy() {
    if (this.timerEnd) {
      clearInterval(this.timerEnd);
    }
    if (this.timerStart) {
      clearInterval(this.timerStart);
    }
  },
  computed: {
    ...mapGetters('Presale', ['activeAfter', 'closedAfter']),
  },
  methods: {
    init() {
      this.endDate = dayjs.unix(this.closedAfter).valueOf();
      this.startDate = dayjs.unix(this.activeAfter).valueOf();
      this.setupCountdownTimer();
    },
    Timer(time) {
      const delta = dayjs.duration(time);
      return {
        d: `0${delta.$d.days}`.slice(-2),
        h: `0${delta.$d.hours}`.slice(-2),
        m: `0${delta.$d.minutes}`.slice(-2),
        s: `0${delta.$d.seconds}`.slice(-2),
      };
    },
    setupCountdownTimer() {
      const { endDate, startDate } = this;
      if (this.startDate) {
        this.timerStart = setInterval(() => {
          this.countdownStart = startDate - dayjs().valueOf();
          if (this.countdownStart <= 0) {
            this.countdownStart = 0;
            clearInterval(this.timerStart);
          }
        }, 1000);
      }
      if (this.endDate) {
        this.timerEnd = setInterval(() => {
          this.countdownEnd = endDate - dayjs().valueOf();
          if (this.countdownEnd <= 0) {
            this.countdownEnd = 0;
            clearInterval(this.timerEnd);
          }
        }, 1000);
      }
    },
  },
};
</script>

<template>
  <v-row class="my-5 countdown">
    <v-col cols="12" sm="6">
      <CountdownBlock :timer="Timer(countdownStart)" :loading="false" header="Starts in" />
    </v-col>
    <v-col cols="12" sm="6">
      <CountdownBlock :timer="Timer(countdownEnd)" :loading="false" header="Ends in" />
    </v-col>
  </v-row>
</template>

<style lang="scss"></style>
